import axios from "axios";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { odcUrls } from "../../URL/ApplicationUrls";
import Odc, { mapFromApiToOdc } from "../Odc";
import { namedQueryKeyWithId } from "../../ReactQuery/namedQueryKeyWithId";

export const useFetchOdc = (odcId: number | string | undefined) => {
  return useQuery<Odc, Error>({
    queryKey: namedQueryKeyWithId("odcs", odcId),
    queryFn: () => fetchOdc(odcId),
    onError: () => {
      toast.error(`An error occurred when retrieving the ODC with the Id ${odcId}`);
    },
  });
};

const fetchOdc = async (id: number | string | undefined) => {
  const { data: odc } = await axios.get<Odc>(odcUrls.editOdc(id).apiUrl);
  return mapFromApiToOdc(odc);
};
